import { gsap } from "gsap";

export default class BackgroundImpressionImage {
	constructor(elm, orientation) {
        this.hoverElm = elm;
        this.parent = this.hoverElm.closest('[data-impressions-hover-parent]');

        this.videoContainer = document.querySelector('[data-background]');

        this.wrapper = document.createElement("div");
        if(orientation=='mobile') {
            this.wrapper.classList.add('c-background__image', 'c-background__image--impression', 'c-background__image--mobile');
        }
        if(orientation=='desktop') {
            this.wrapper.classList.add('c-background__image', 'c-background__image--impression', 'c-background__image--desktop');
        }

        gsap.set(this.wrapper, {top: 5000, opacity: 0});
        this.videoContainer.appendChild(this.wrapper);

        if(orientation=='mobile') {
            const content = JSON.parse(this.hoverElm.getAttribute('data-impression-image-mobile'));
            this.wrapper.innerHTML = content;
        }
        if(orientation=='desktop') {
            const content = JSON.parse(this.hoverElm.getAttribute('data-impression-image-desktop'));
            this.wrapper.innerHTML = content;
        }


        if(orientation=='mobile') {
            this.hoverElm.addEventListener('touchstart', () => {
                this.show();
            });
            this.hoverElm.addEventListener('touchend', () => {
                this.hide();
            });
        }
        if(orientation=='desktop') {
            this.hoverElm.addEventListener('mouseenter', () => {
                this.show();
            });
            this.hoverElm.addEventListener('mouseleave', () => {
                this.hide();
            });
        }

	}

    show() {
        this.parent.classList.add('c-impressions-hover-parent');
        this.fadeIn();
    }

    hide() {
        this.parent.classList.remove('c-impressions-hover-parent');
        this.fadeOut();
    }

    fadeIn() {
        gsap.set(this.wrapper, {top: 0});
        gsap.killTweensOf(this.wrapper);
        gsap.to(this.wrapper, {
            duration: 0.3,
            opacity: 1,
            ease: "none"
        });
    }

    fadeOut() {
        return new Promise((resolve) => {
            gsap.killTweensOf(this.wrapper);
            gsap.to(this.wrapper, {
                duration: 0.3,
                opacity: 0,
                ease: "none",
                onComplete: () => {
                    resolve();
                }
            });
        });
    }

    destroy() {
        const opacity = gsap.getProperty(this.wrapper, "opacity");
        if(opacity>0) {
            this.fadeOut().then(() => {
                this.wrapper.remove();
            });
        } else {
            this.wrapper.remove();
        }
    }

}